import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Input, Button } from 'reactstrap';

import styles from './index.module.scss';
import FormFieldTranslations from '../formFields/FormFieldTranslations';
import { Field } from 'react-final-form';

const propTypes = {
    emailList: PropTypes.arrayOf(PropTypes.string),
    setEmailList: PropTypes.func,
    emailLabel: PropTypes.string,
    buttonsLabels: PropTypes.shape({
        addEmail: PropTypes.string,
        removeEmail: PropTypes.string,
    })
};

function makeEmptyRecipientFromTemplate(form: any)
{
    const iv = form.getState().initialValues;
    const template = iv?.content?.recipients?.[0] ?? null;
    const nameKeys =
    template
        ? Object.keys(template).filter(k => k.startsWith("name-") && k.endsWith("-translations"))
        : ["name-Pl-translations", "name-En-translations"]; // fallback
    const emptyTranslations = Object.fromEntries(nameKeys.map(k => [k, ""]));
    return { email: "", ...emptyTranslations };
}

const EmailListController = ({
    form,
    // emailList,
    // setEmailList,
    emailLabel,
    buttonsLabels,
    // recipients,
    currentIso
}) =>
{
    const recipients = form.getState().values?.content?.recipients ?? [];

    const setRecipients = (nextRecipients) =>
    {
        const state = form.getState();
        form.initialize({
            ...state.values,
            content: {
                ...state.values?.content,
                recipients: nextRecipients,
            },
        });
    };

    const handleAddEmail = () =>
    {
        const newItem = makeEmptyRecipientFromTemplate(form);
        setRecipients([...recipients, newItem]);
    };

    const handleRemoveEmail = (index) => () =>
    {
        setRecipients(recipients.filter((_: any, i: number) => i !== index));
    };

    return (
        <div className={clsx('my-3', styles.container)}>
            {
                recipients.map(((email, index) => (
                    <div key={`emailEditionField-${index}`} className={clsx('my-2')}>
                        {/* <Label for={`emailField${index}`}>{emailLabel} {index + 1}</Label> */}
                        <div className='d-flex'>
                            <div className='d-flex flex-column flex-grow-1' style={{ gap: '0.5rem' }}>
                                <FormFieldTranslations
                                    form={form}
                                    propertyName={`content.recipients.${index}.name`}
                                    currentIso={currentIso}
                                    label={`${emailLabel} ${index + 1}`}
                                    modalHeader={`${emailLabel} ${index + 1}`}
                                />
                                <Field name={`content.recipients.${index}.email`}>
                                    {({ input }) => <Input type="email" id={`emailField${index}`} {...input} />}
                                </Field>
                                {/* <Input type="email" id={`emailField${index}`} value={email} onChange={event => handleSetEmail(event, index)} /> */}
                            </div>
                            <div>
                                <Button
                                    className='ml-2'
                                    color='danger'
                                    onClick={handleRemoveEmail(index)}
                                >
                                    <span>{buttonsLabels.removeEmail}</span>
                                </Button>
                            </div>
                        </div>
                    </div>
                )))
            }
            <Button
                className='mt-3 ml-auto'
                color='primary'
                onClick={handleAddEmail}
            >
                <span>{buttonsLabels.addEmail}</span>
            </Button>
        </div>
    );
};

EmailListController.propTypes = propTypes;

export default EmailListController;